// extracted by mini-css-extract-plugin
export default {"wrapper":"InvestmentHistoryPage_wrapper__YgB2r"};